import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextTooltipOnHover from '../../Tooltip/TextTooltipOnHover';
import FolderSyncIcon from '../../Icons/FolderSync';
import cardStyles from '../FolderCard.scss';
import s from './FolderSyncIndicator.scss';
var FolderSyncIndicator = function (props) {
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(cardStyles['subfolders-icon'], cardStyles['icon-with-tooltip'], cardStyles['wix-portfolio-sync-feature'], s['root']) },
        React.createElement(TextTooltipOnHover, { tooltipText: t('wixPortfolio.folderSync.synced') },
            React.createElement(FolderSyncIcon, { disableDefaultColors: true }))));
};
FolderSyncIndicator.displayName = 'FolderSyncIndicator';
export default FolderSyncIndicator;
//# sourceMappingURL=FolderSyncIndicator.js.map